import React, { ButtonHTMLAttributes } from "react";
import { CancelIcon } from "../icons/CancelIcon";

export function CancelCircleButton(props: ButtonHTMLAttributes<any>) {

    return (
        <button {...props}>
            <CancelIcon />
        </button>
    );
}
